import React from 'react';
import PropTypes from 'prop-types';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import classnames from 'classnames';
import { MpgEntities } from 'client/data/models/mpg';
import { MPGE_ENGINES } from 'site-modules/shared/constants/mpg';

export function EpaMpg({ style: { engineType, mpgData, mpgeData }, cityPercents }) {
  const isMpge = MPGE_ENGINES.includes(engineType);
  const { combined, city, highway } = isMpge ? mpgeData : mpgData;

  const combinedDisplay =
    city && highway ? Math.round(city * (cityPercents / 100) + highway * ((100 - cityPercents) / 100)) : combined;

  return (
    <div className="epa-mpg">
      <div className="heading-4 text-center mb-1">
        {combinedDisplay ? `${combinedDisplay} ${isMpge ? 'MPGe*' : 'MPG'}` : 'Not Available'}
      </div>
      <Row className={classnames({ 'mb-2': isMpge && !!combined })}>
        <Col xs={6} className="city text-center pt-0_25">
          <i className="size-24 icon-office mb-0_5 text-turquoise-30" aria-hidden />
          <div className="medium">
            <span className="text-cool-gray-30 fw-bold size-16">{city || 'N/A'}</span> City
          </div>
        </Col>
        <Col xs={6} className="text-center pt-0_25">
          <i className="size-24 icon-road mb-0_5 text-turquoise-30" aria-hidden />
          <div className="medium">
            <span className="text-cool-gray-30 fw-bold size-16">{highway || 'N/A'}</span> Highway
          </div>
        </Col>
      </Row>
      {isMpge && !!combined && (
        <div className="medium mt-auto">
          <sup>*</sup>MPG equivalent. 1 MPGe = 1 mi / 33.7 kWh
        </div>
      )}
    </div>
  );
}

EpaMpg.propTypes = {
  style: MpgEntities.StyleMpg.isRequired,
  cityPercents: PropTypes.number.isRequired,
};
